module.exports = __webpack_public_path__ + "static/media/3.50a21d34.png";